import React from 'react';
import HoverPopperPopupState, {popNavMenuStyles as styles} from '../PopNav-menu';
import {dummyMenuData} from '@/util/menu-links/index';
import type {NavTopLevelItem} from '@/types/navigation';
import Icon from '@/components/atoms/Icon';

interface DesktopMenuProps {
    openIndex: number;
    onSelect: (index: number) => void;
}

const DesktopMenu: React.FC<DesktopMenuProps> = ({openIndex, onSelect}) => {
    return (
        <>
            {dummyMenuData?.map((item: NavTopLevelItem) => (
                <HoverPopperPopupState
                    key={item.btnLabel}
                    btnClassName="mui-header-options-button"
                    popupId={item.btnLabel}
                    btnLabel={
                        item.path === null ? (
                            <span className={`nav-button-content ${styles.buttonContent}`}>
                                <span className="nav-button-label">{item.btnLabel}</span>
                                <Icon
                                    name="KeyboardArrowDown"
                                    fontSize="inherit"
                                    className={`nav-dropdown-arrow ${styles.dropdownArrow}`}
                                />
                            </span>
                        ) : (
                            item.btnLabel
                        )
                    }
                    menuData={item.menus}
                    path={item.path}
                    navType="full-nav"
                    multiSubChild={item.multiSubChild ?? false}
                    selector={openIndex}
                    onSelect={onSelect}
                />
            ))}
        </>
    );
};

export default DesktopMenu;
